<!-- Not collected achivement's block -->
<template>
	<transition-height name="fade">
		<div v-if="notCollectedAchievements.length">
			<div class="row">
				<div class="col-xs-12 block-title">
					{{ t.challengesCompletedTitle }}
				</div>
			</div>
			
			<div class="challenge-list list-not-collected">
				<ChallengeNotCollected v-for="item in notCollectedAchievements" :key="item.id" :item="item" />
			</div>
		</div>
	</transition-height>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import ChallengeNotCollected from './challenge-not-collected.vue';
import axios from 'axios';
import { toastError } from '@/js/includes/toast';
import { useStore } from '@/js/stores';
import { $on } from '@/js/includes/event-bus';
import { useChallenges } from '@/js/stores/challenges';
import { updateUserPoints } from '@/js/classes/user';

const store = useStore()
const { removeChallengeById } = useChallenges()

// Reactives
const notCollectedAchievements = ref([])
const loadingAchievements = ref(true)

// Computeds
const t = computed(() => store.translations)

// Methods
// Load achievements which are not yet collected by user
function loadNotCollectedAchievements() {
	loadingAchievements.value = true

	axios.get('/api/user-side/getUserNotCollectedAchievements')
		.then(response => {
			if(Array.isArray(response.data)) notCollectedAchievements.value = response.data
		}).catch(e => {
			toastError("Error: " + e.response?.data?.error_code)
		}).finally(() => {
			loadingAchievements.value = false
		})
}

// Lifecycle
onMounted(() => {
	loadNotCollectedAchievements()
})

$on('achievement-collected', item => {
	removeChallengeById(item.id)

	notCollectedAchievements.value.splice(notCollectedAchievements.value.indexOf(item), 1)
	updateUserPoints()
})

$on('challenge-completed-outside', () => {
	loadNotCollectedAchievements()
})

$on('facebook-connected', () => {
	loadNotCollectedAchievements()
})

</script>